import cleanData from '../cleanData'

export const UPDATE_LEFT_SIDE_DATA = 'UPDATE_LEFT_SIDE_DATA'
export const UPDATE_RIGHT_SIDE_DATA = 'UPDATE_RIGHT_SIDE_DATA'
export const UPDATE_BRANDING_DATA = 'UPDATE_BRANDING_DATA'
export const GENERATE_FROM_SAMPLE = 'GENERATE_FROM_SAMPLE'
export const RESET_DATA = 'RESET_DATA'

//Branding type
export type BrandingType = typeof cleanData.branding
//right side data type
export type RightSideType = typeof cleanData.rightSide
//left side data type
export type LeftSideType = typeof cleanData.leftSide

//cv Data type
export type CvDataStateType = typeof cleanData

// action types
export type RightSideAction = {
	type: typeof UPDATE_RIGHT_SIDE_DATA
	rightSide: RightSideType
}

export type LefttSideAction = {
	type: typeof UPDATE_LEFT_SIDE_DATA
	leftSide: LeftSideType
}

export type BrandingAction = {
	type: typeof UPDATE_BRANDING_DATA
	branding: BrandingType
}

export type GenerateSampleAction = {
	type: typeof GENERATE_FROM_SAMPLE
	data: CvDataStateType
}
export type ResetAction = {
	type: typeof RESET_DATA
}

//main app state action
export type AppAction =
	| LefttSideAction
	| RightSideAction
	| BrandingAction
	| GenerateSampleAction
	| ResetAction
